module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAUBJREFUOE+1lD1KA0EcxX9vxVLRJnZeIIInsNMm4EcjeIAQEEQkQjxDUpgioBBiL1YGIYXaeQLBXMBOm4iWkv2Lm82XmQlLWLecmf3NvDdvnkj5U8o8vEDbPssiyyO2gNV441fQPSFXuiu3XYeZAFqhMM/70jlmh6A5twLrouCCTOdU9fr36JoxYAR7W26BbSazQo+sdHKj0HHgXqmGceSAhfFYMDEn1XRbPu6PD4CRZ0H47JQp8tEPRmNyM+sSBut9T4fAnVIVceKUKuV6QGu5rVBVzXLxd24I3C29ANnZgLTVrKz9BX4CCzMCv9SsLP470C8ZruOTH3ji5JA87VLgKQZtJL+UabGBfcyEdJM4NlEqvMG2bg/keIq+YEfAtJ/eAJqoHHRJ5qM4tRxG/fHWl/GAqZG4vpK1jH9V6o39A23ljxUTBfzrAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/top_icon_error.png
// module id = XEsc
// module chunks = 0